export interface SearchFormProps<T extends SearchParams> {
  getUrlSearchParams: (searchParams: T) => URLSearchParams;
  filterForm?: React.ReactNode | null;
  defaultValue?: T | any;
}

export const keywordDefinition: SearchCriteriaDisplayDefinition = {
  key: 'keyword',
  label: 'Keyword',
  displayFunc: (value: string) => value,
};

export interface SearchParams {
  keyword?: string;
}

export interface SearchCriteriaDisplayDefinition {
  key: string;
  label: string;
  displayFunc: (value: any) => any;
}
